import { render, staticRenderFns } from "./BasePageActions.vue?vue&type=template&id=bba97a8e&"
import script from "./BasePageActions.vue?vue&type=script&lang=js&"
export * from "./BasePageActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports